import React from 'react';
import {
    Empty, Checkbox, Button, message, Col, Row, Card, Spin, Tabs, Table, Input, Space, Transfer, ConfigProvider, Modal
} from 'antd';
import { PlusOutlined, CloseOutlined, SearchOutlined } from '@ant-design/icons';
import { APIService } from '../../../../services/projectManager/api';
import { CalendarTimeService } from '../../../../services/calendar/calendar.tool.service.js';
import { __waterDocumentSvg } from '../../../../lib/waterMarking.js';
import {PMAPI,PMENUM} from '../../../../lib/postmsg';
import reactDialog from '../../../../lib/editableDialog';
import './RoleManager.scss';
import 'antd/dist/antd.css';
import  zhCN  from  'antd/es/locale/zh_CN'
import moment from 'moment';
import 'moment/locale/zh-cn';
import locale from 'antd/es/date-picker/locale/zh_CN';


class SettingPanel extends React.Component{

    constructor(props) {
        super(props);

        this.state = {
            dataSource: [
            ],
            targetKeys: [],
            loading: false,
            sourceKeys: [],
            pagination: {
                pageSize: 100,
            },
        };
    }

    componentDidMount() {
        const userInfo = window.config.sysConfig ? window.config.sysConfig.userInfo : window.config;
        __waterDocumentSvg({
            container : document.getElementById('role-setting-panel'),
            // content : `${userInfo.user_department} ${userInfo.username} ${CalendarTimeService.getDayDate()}`,
            content : `${userInfo.user_department} ${userInfo.name} ${CalendarTimeService.getDayDate()}`,
            width : '700px',
            height : '550px',
            opacity : '0.1',
            fontSize : '26px',
            zIndex : 2000
        })
        const { type, record, deptType } = this.props.data;
        if(type=='人员权限'){
            this.getData(deptType, record)
        }else{
            this.getData(deptType, record)
        }
    }

    getData = (deptType, record) => {
        this.setState((prev, props) => {
            return { loading: true }
        })
        const { type } = this.props.data;
        let param;
        if(type == '人员权限'){
            param = {
                action: 'user',
                user_id: record.id,
                department_type: deptType
            }
        }else{
            param = {
                action: 'project',
                project_number: record.id
            }
        }
        APIService.GetProjectPermissionInfo(param).then(res => {
            if (res.success) {
                this.setState((prev, props) => {
                    return { 
                        dataSource: res.data['other'], 
                        targetKeys: res.data['checked'], sourceKeys: res.data['checked'], 
                        loading: false 
                    }
                })
            }else{
                console.log('获取人员权限项目信息error', res.error)
                message.error(res.error)
                this.setState((prev, props) => {
                    return { loading: false }
                })
            }
        }).catch(err => {
            console.log('获取人员权限项目信息Error', err)
            this.setState((prev, props) => {
                return { loading: false }
            })
        })
    };

    onChange =  (newTargetKeys, direction, moveKeys) => {
        this.setState((prev, props) => {
            return { targetKeys: newTargetKeys }
        })
        if(this.props.data.event.onChange){
            this.props.data.event.onChange(newTargetKeys);
        }
    };

    filterOption = (inputValue, option) =>{
        inputValue = inputValue.replace(/\s+/g,'')
        return  option.project_name.indexOf(inputValue) > -1;
    }


    handleSearch = (dir, value) => {
        console.log('search:', dir, value);
    };

    render(){
        const { dataSource, targetKeys, loading, sourceKeys, pagination } = this.state;
        const { type, record } = this.props.data;
        let title = type=='人员权限'?'项目列表': '人员列表';
        let card_title = type == '人员权限' ? `${record.name}-${record.username}`:`${record.project_number}-${record.project_name}`
        return(
            <div 
                id="role-setting-panel"
                style={{padding: 20, height: '100%'}}
            >
                <ConfigProvider locale={zhCN}>
                <Spin spinning={loading} style={{height: '100%'}}>
                    <Card
                        style={{height: '100%'}}
                        headStyle={{height: '65px'}}
                        bodyStyle={{height: 'calc(100% - 65px)'}}
                        title={card_title}
                        extra={
                            <Button
                                type="primary"
                                onClick={() => {
                                    if(targetKeys.length == 0){
                                        let that = this;
                                        Modal.confirm({
                                            cancelText: '取消',
                                            centered: true,
                                            content: '检测到您暂未选择任何数据,确定提交会清空该用户所有项目权限!',
                                            okText: '确定',
                                            onOk: () => {
                                                that.props.data.event.close(record, targetKeys, sourceKeys)
                                            }
                                        })
                                    }else{
                                        this.props.data.event.close(record, targetKeys, sourceKeys)
                                    }
                                }}
                            >
                                保存
                            </Button>
                        }
                    >
                        <Transfer
                            style={{height: '100%'}}
                            rowKey={record => record.id}
                            listStyle={(direction) => {return {width: '100%', height: '100%'}}}
                            titles={[`未分配的${title}`, `已分配的${title}`]}
                            showSearch
                            showSelectAll
                            operations={['添加权限', '取消权限']}
                            dataSource={dataSource}
                            targetKeys={targetKeys}
                            onSearch={this.handleSearch}
                            onChange={this.onChange}
                            render={item => type=='人员权限'?`${item.project_number}-${item.project_name}`: `${item.name}-${item.username}`}
                            pagination={pagination}
                            filterOption={this.filterOption}
                        />
                    </Card>
                </Spin>
                </ConfigProvider>
            </div>
        )
    }

}


class RoleManager extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            tab: '人员权限',
            visible: false,
            loading: false,
            deptType: null,
            pagination: {
                current: 1,
                pageSize: 20,
                showSizeChanger: true,
                total: 0,
                showQuickJumper: true,
                itemRender: (current, type, originalElement) => {
                    if (type === 'prev') {
                        return <Button size="small" style={{marginRight: 3}}>上一页</Button>;
                    }
                    if (type === 'next') {
                        return <Button size="small" style={{marginLeft: 3}}>下一页</Button>;
                    }
                    return originalElement;
                }
            },
            deptCols: [
                {
                    title: '部门',
                    dataIndex: 'name',
                    key: 'name',
                },
            ],
            deptData: [
                
            ],
            userCols: [
                {
                    title: '用户',
                    dataIndex: 'name',
                    key: 'name',
                },
                {
                    title: '用户姓名',
                    dataIndex: 'username',
                    key: 'username',
                },
                // {
                //     title: '可查看的项目列表',
                //     dataIndex: 'projects',
                //     ellipsis: true,
                //     key: 'projects',
                //     render: (text, record) => {
                //         if(record['projects']){
                //             return record['projects'].join(',');
                //         }else{
                //             return '--'
                //         }
                //     },
                // },
                {
                    title: '可查看的项目个数',
                    key: 'projects_num',
                    render: (text, record) => {
                        if(record['projects']){
                            return record['projects'].length;
                        }else{
                            return '0'
                        }
                    },
                },
                {
                    title: '权限设置',
                    key: 'setting',
                    render: (text, record) => {
                        if(record['username'] && record['username'] != ''){
                            return <Button 
                                    type="primary" size="small" 
                                    onClick={() => this.openSettingPanel(record)}
                                >设置</Button>
                        }
                    }
                }
            ],
            userData: [
            ],
            projCols: [
                {
                    title: '项目编号',
                    dataIndex: 'project_number',
                    key: 'project_number',
                },
                {
                    title: '项目简称',
                    dataIndex: 'project_name',
                    key: 'project_name',
                    ellipsis: true,
                },
                // {
                //     title: '可查看的人员列表',
                //     dataIndex: 'users',
                //     key: 'users',
                //     ellipsis: true,
                //     render: (text, record) => {
                //         if(record['users']){
                //             return record['users'].join(',');
                //         }else{
                //             return '--'
                //         }
                //     },
                // },
                {
                    title: '可查看的人员个数',
                    key: 'users_num',
                    render: (text, record) => {
                        if(record['users']){
                            return record['users'].length;
                        }else{
                            return '0'
                        }
                    },
                },
                {
                    title: '权限设置',
                    key: 'setting',
                    render: (text, record) => {
                        if(record['project_number'] && record['project_number'] != ''){
                            return <Button 
                                type="primary" size="small"
                                onClick={() => this.openSettingPanel(record)}
                            >设置</Button>
                        }
                    }
                }
            ],
            projData: [],
            targetSelect: [],
            selectDept: '',
        };
    }


    componentDidMount() {
        const userInfo = window.config.sysConfig ? window.config.sysConfig.userInfo : window.config;
        __waterDocumentSvg({
            container : document.getElementById('role-manager'),
            // content : `${userInfo.user_department} ${userInfo.username} ${CalendarTimeService.getDayDate()}`,
            content : `${userInfo.user_department} ${userInfo.name} ${CalendarTimeService.getDayDate()}`,
            width : '700px',
            height : '550px',
            opacity : '0.1',
            fontSize : '26px',
            zIndex : 1000
        })
        this.getData({action: 'user'})
    }

    getData = (param) => {
        this.setState((prev, props) => {
            return { loading: true }
        })
        APIService.GetProjectPermissionInfo(param).then(res => {
            if (res.success) {
                this.setState((prev, props) => {
                    if(param['action'] == 'user'){
                        return { deptData: res.data, loading: false, deptType: res.department_type }
                    }else{
                        return { projData: res.data, loading: false }
                    }
                })
            }else{
                console.log('获取权限信息error', res.error)
                message.error(res.error)
                this.setState((prev, props) => {
                    return { loading: false }
                })
            }
        }).catch(err => {
            console.log('获取权限信息Error', err)
            this.setState((prev, props) => {
                return { loading: false }
            })
        })
    };
    
    changeTab = key => {
        this.setState((prev, props) => {
            return {tab: key}
        }, () => {
            if(key == '人员权限'){
                this.getData({action: 'user'})
            }else{
                this.getData({action: 'project'})
            }
        })
    };

    tableChange = (paginations, filters, sorter) => {
        const {pagination} = this.state;
        pagination.pageSize = paginations.pageSize;
        pagination.current = paginations.current;
        this.setState({pagination})
        console.log('tableChange', paginations, filters, sorter)
    };

    openSettingPanel = (record) => {
        let theModal = reactDialog;
        const { tab } = this.state;
        let that = this;
        theModal.show({
            title: `设置${tab}`,
            className: 'role-setting',
            el: SettingPanel,
            type: tab,
            record: record,
            iszoom:true,
            deptType: this.state.deptType,
            event: {
                onChange: (values) => {
                    that.setSelect(values);
                },
                close: (record, targetKeys, sourceKeys) => {
                    that.save(record, targetKeys, sourceKeys);
                    theModal.hide();
                }
            }
        })
    };
    
    save = (record, targetKeys, sourceKeys) => {
        const { tab, selectDept, deptType } = this.state;
        let param, reloadParam;
        if(tab == '人员权限'){
            param = {
                action: 'user',
                user: record.id,
                project_numbers: JSON.stringify(targetKeys),
                checked: JSON.stringify(sourceKeys),
            }
        }else{
            param = {
                action: 'project',
                usernames: JSON.stringify(targetKeys),
                checked: JSON.stringify(sourceKeys),
                project_number: record.project_number,
                project_name: record.project_name
            }
        }
        APIService.AddProjectPermission(param).then(res => {
            if(res.success){
                message.success('设置项目管理权限成功!')
                // this.props.data.event.closeDialog();
                if(tab == '人员权限'){
                    this.getDeptUser(selectDept);
                }else{
                    this.getData({action: 'project'});
                }
            }else{
                message.error(`设置项目管理权限失败,Error:${res.error}`)
            }
        }).catch(err => {
            console.log('设置项目管理权限失败Error', err)
        })
        console.log('save', record, targetKeys, sourceKeys)
    };

    setSelect = (values) => {
        this.setState((prev, props) => {
            return { targetSelect: values }
        })
    };
    
    getDeptUser = (record) => {
        const { deptType } = this.state;
        this.setState((prev, props) => {
            return { loading: true, selectDept: record }
        })
        let param = {
            department_id: record.id,
            department_type: deptType
        }
        APIService.GetProjectPermissionInfo(param).then(res => {
            if(res.success){
                console.log('res', res)
                this.setState((prev, props) => {
                    return { loading: false, userData: res.data }
                })
            }else{
                this.setState((prev, props) => {
                    return { loading: false }
                })
            }
        }).catch(err => {
            console.log(`获取${record['name']}人员信息失败,Error: ${err}`)
            this.setState((prev, props) => {
                return { loading: false }
            })
        })
    };

    rowClick = record => {
        this.getDeptUser(record);
    };

    setClassName = (record, index) => {
        return record.id === this.state.selectDept.id ? 'checked' : '';
    };

    render(){
        const { tab, pagination, loading } = this.state;
        let cols, data;
        if(tab == '人员权限'){
            cols = this.state.userCols;
            data = this.state.userData;
        }else{
            cols = this.state.projCols;
            data = this.state.projData;
        }
        return(
            <div
                id="role-manager"
            >   
            <ConfigProvider locale={zhCN}>
                <Card
                    className = 'tabhuan'
                    style={{ width: '100%' }}
                    tabList={[{key:'人员权限', tab: '人员权限'}, {key:'项目权限', tab: '项目权限'}]}
                    activeTabKey={this.state.tab}
                    // tabBarExtraContent={<a href="#">More</a>}
                    onTabChange={this.changeTab}
                    bodyStyle={{height: '100%'}}
                >
                {
                    tab == '人员权限' ?
                    <Row>
                        <Col span={6}>
                            <Card
                                title="部门信息"
                                size="small"
                                bodyStyle={{height: '100%'}}
                            >
                                <Table
                                    rowKey={record => record.id}
                                    size="small"
                                    defaultExpandAllRows={false}
                                    pagination={false}
                                    columns={this.state.deptCols}
                                    dataSource={this.state.deptData}
                                    loading={loading}
                                    expandRowByClick={true}
                                    rowClassName={this.setClassName}
                                    onChange={this.tableChange}
                                    onRow={record => {
                                        return {
                                            onClick: (event) => {
                                                console.log('event', event)
                                                this.rowClick(record)
                                            }
                                        }
                                    }}
                                />
                            </Card>
                        </Col>
                        <Col span={18}>
                            <Card
                                title={this.state.selectDept?`${this.state.selectDept.name}-人员信息`: '人员信息'}
                                size="small"
                                bodyStyle={{height: '100%'}}
                            >
                                <Table
                                    rowKey={record => record.id}
                                    size="small"
                                    defaultExpandAllRows={false}
                                    pagination={pagination}
                                    columns={cols}
                                    loading={loading}
                                    dataSource={data}
                                    onChange={this.tableChange}
                                />
                            </Card>
                        </Col>
                    </Row>:
                    <Table
                        className="ProjectPermissions"
                        rowKey={record => record.id}
                        size="small"
                        defaultExpandAllRows={false}
                        pagination={pagination}
                        columns={cols}
                        loading={loading}
                        dataSource={data}
                        onChange={this.tableChange}
                    />
                }
                </Card>
            </ConfigProvider>
            </div>
        )
    }
}

export default RoleManager;


// WEBPACK FOOTER //
// app/components/customPage/project-manager/RoleManager/RoleManager.jsx